export const OPEN_CANVAS_FOCUS_SINK_ID = 'open-canvas-focus-sink';
export const OPEN_CANVAS_FOCUS_SINK_AUTOMATION_ID = OPEN_CANVAS_FOCUS_SINK_ID;

export const focusOpenCanvasSink = (doc: Document): boolean => {
  const sink = doc.getElementById(OPEN_CANVAS_FOCUS_SINK_ID);
  if (!(sink instanceof HTMLElement)) return false;

  sink.focus({preventScroll: true});
  return doc.activeElement === sink;
};
